<template>
  <div class="animated fadeIn">
    <HeaderPadrao class="mb-2" icon="fa fa-shopping-cart" titulo="CADASTRO DE VENDEDOR">
      <template #subtitulo>
        <div class="d-flex align-items-center flex-wrap">
          <span class="mr-2">
            <i class="fa fa-id-card-o mr-1 text-info"></i>
            CÓDIGO: <strong class="text-white">{{registro.CODIGO || 'Novo'}}</strong>
          </span>
          <span v-if="registro.NOME" class="mx-2">•</span>
          <span v-if="registro.NOME" class="mr-2">
            <i class="fa fa-user mr-1 text-info"></i>
            {{registro.NOME.substring(0,30)}}
          </span>
          
          <div class="ml-3 d-flex align-items-center">
            <b-badge :variant="registro.STATUS === '1' ? 'success' : 'danger'" pill class="px-3 py-1 shadow-sm mr-2">
              {{registro.STATUS === '1' ? 'ATIVO' : 'INATIVO'}}
            </b-badge>
            
            <b-badge v-if="registro.AREA" variant="info" pill class="px-3 py-1 shadow-sm mr-2">
              {{registro.AREA === '0' ? 'INTERNO' : 'EXTERNO'}}
            </b-badge>

            <b-badge variant="light" pill class="px-3 py-1 shadow-sm text-dark">
              VENDEDOR
            </b-badge>
          </div>
        </div>
      </template>

      <template #acoes>
        <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="post()">
          <i class="fa fa-save mr-1"></i> GRAVAR
        </b-button>

        <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="$router.go(-1)">
          <i class="fa fa-arrow-left mr-1"></i> Voltar
        </b-button>
      </template>
    </HeaderPadrao>

    <b-row class="px-2">
      <b-col sm="12">
        <!-- Identificação -->
        <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
          <template #header>
            <div class="d-flex align-items-center">
              <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                <i class="fa fa-id-card"></i>
              </div>
              <div>
                <h6 class="mb-0 font-weight-bold">Identificação e Dados Básicos</h6>
                <small class="text-muted">Nome, CPF/CNPJ e situação do vendedor</small>
              </div>
            </div>
          </template>

          <b-row class="mb-4 align-items-center">
            <b-col sm="2">
              <label class="modal-label-premium d-block mb-2">Status</label>
              <b-form-checkbox id="checkbox-status" v-model="registro.STATUS" value="1" switch unchecked-value="0">
                {{ registro.STATUS === '1' ? 'Ativo' : 'Inativo' }}
              </b-form-checkbox>
            </b-col>
            <b-col sm="2">
              <label class="modal-label-premium">Código</label>
              <b-form-input type="text" id="ID" :disabled="true" placeholder="Automático" v-model="registro.CODIGO" class="rounded-pill shadow-xs bg-light"></b-form-input>
            </b-col>
            <b-col sm="2">
              <label class="modal-label-premium">Tipo de Pessoa *</label>
              <b-form-select :plain="true" v-model="registro.FIZ_JUR" :options="optionsTipoPessoa" class="rounded-pill shadow-xs"></b-form-select>
            </b-col>
            <b-col sm="3">
              <label class="modal-label-premium">Tipo de Contrato *</label>
              <b-form-select :plain="true" v-model="registro.TIPO_CONTRATO" :options="optionsTipoContrato" class="rounded-pill shadow-xs"></b-form-select>
            </b-col>
            <b-col sm="3" v-if="registro.FIZ_JUR === '1'">
              <label class="modal-label-premium">CNPJ</label>
              <b-input-group>
                <the-mask class="form-control rounded-pill-left shadow-xs" id="inputCNPJ" ref="inputCNPJ" mask="##.###.###/####-##" placeholder="00.000.000/0000-00" v-model="registro.CPF"></the-mask>
                <b-input-group-append>
                  <b-button variant="soft-primary" class="rounded-pill-right shadow-xs px-3 font-weight-bold" @click.stop.prevent="consultarJuridica()">
                    <i class="fa fa-search mr-1"></i> Consultar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col sm="3" v-else>
              <label class="modal-label-premium">CPF</label>
              <the-mask class="form-control rounded-pill shadow-xs" id="inputCPF" ref="inputCPF" mask="###.###.###-##" placeholder="000.000.000-00" v-model="registro.CPF"></the-mask>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="6">
              <label class="modal-label-premium">Nome Completo *</label>
              <b-form-input type="text" id="nome" placeholder="Informe o Nome Completo" v-model="registro.NOME" :state="nomeValid" class="rounded-pill shadow-xs"></b-form-input>
            </b-col>
            <b-col sm="6">
              <label class="modal-label-premium">Nome Resumido (Apelido)</label>
              <b-form-input type="text" id="nomefantasia" placeholder="Informe o Nome Resumido" v-model="registro.REZUMIDO" class="rounded-pill shadow-xs"></b-form-input>
            </b-col>
          </b-row>
        </b-card>

        <!-- Endereço -->
        <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
          <template #header>
            <div class="d-flex align-items-center">
              <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                <i class="fa fa-map-marker"></i>
              </div>
              <div>
                <h6 class="mb-0 font-weight-bold">Endereço e Localização</h6>
                <small class="text-muted">Dados de localização do vendedor</small>
              </div>
            </div>
          </template>

          <b-row class="mb-3">
            <b-col sm="10">
              <label class="modal-label-premium">Endereço</label>
              <b-form-input type="text" id="endereco" placeholder="Rua, Avenida, etc." v-model="registro.ENDERECO" class="rounded-pill shadow-xs"></b-form-input>
            </b-col>
            <b-col sm="2">
              <label class="modal-label-premium">Número</label>
              <b-form-input type="text" id="numero" placeholder="Nº" v-model="registro.NUMERO" class="rounded-pill shadow-xs"></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col sm="8">
              <label class="modal-label-premium">Bairro</label>
              <b-form-input type="text" id="bairro" placeholder="Bairro" v-model="registro.BAIRRO" class="rounded-pill shadow-xs"></b-form-input>
            </b-col>
            <b-col sm="1">
              <label class="modal-label-premium">UF *</label>
              <b-form-select v-model="registro.ID_UF" :options="estados" value-field="ID" text-field="ID" :state="!!registro.ID_UF" class="rounded-pill shadow-xs"></b-form-select>
            </b-col>
            <b-col sm="3">
              <label class="modal-label-premium">Município *</label>
              <div class="d-flex align-items-center">
                <b-form-select :plain="true" v-model="registro.ID_MUNICIPIO" :options="municipios.items" :disabled="municipios.busy || !registro.ID_UF" :state="!!registro.ID_MUNICIPIO" value-field="ID" text-field="NOME" class="rounded-pill shadow-xs flex-grow-1"></b-form-select>
                <b-spinner v-if="municipios.busy" small class="ml-2 text-primary"></b-spinner>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="4">
              <label class="modal-label-premium">Telefone</label>
              <the-mask class="form-control rounded-pill shadow-xs" id="telefone" mask="(##)#####-####" placeholder="(00)00000-0000" v-model="registro.TELEFONE"></the-mask>
            </b-col>
          </b-row>
        </b-card>

        <!-- Áreas e Metas -->
        <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
          <template #header>
            <div class="d-flex align-items-center">
              <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                <i class="fa fa-line-chart"></i>
              </div>
              <div>
                <h6 class="mb-0 font-weight-bold">Áreas e Metas</h6>
                <small class="text-muted">Configurações de atuação e objetivos</small>
              </div>
            </div>
          </template>

          <b-row>
            <b-col sm="4">
              <label class="modal-label-premium">Área de Atuação *</label>
              <b-form-select :plain="true" v-model="registro.AREA" :state="!!registro.AREA" :options="areaAtuacao" class="rounded-pill shadow-xs"></b-form-select>
            </b-col>
            <b-col sm="4">
              <label class="modal-label-premium">Meta Mensal *</label>
              <vue-autonumeric v-model="registro.VL_META" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" :class="['form-control rounded-pill shadow-xs', { 'is-valid' : registro.VL_META, 'is-invalid' : !registro.VL_META }]"></vue-autonumeric>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'

export default {
  components: {
    VueAutonumeric,
    HeaderPadrao
  },
  data () {
    return {
      desabilitado: true,
      items: [],
      registro: {},
      estados: [],
      municipios: {
        items: [],
        busy: false
      },
      status: '',
      optionsStatus: [
        { value: '0', text: 'Inativo' },
        { value: '1', text: 'Ativo' },
      ],
      optionsTipoPessoa: [
        { value: null, text: 'Informe a Pessoa' },
        { value: '0', text: 'Física' },
        { value: '1', text: 'Jurídica' }
      ],
      optionsTipoContrato: [
        { value: null, text: 'Informe o Contrato' },
        { value: '0', text: 'Vendedor Contratado' },
        { value: '1', text: 'Vendedor Representante' }
      ],
      areaAtuacao: [
        {value: '0', text: '0 - Interno'},
        {value: '1', text: '1 - Externo'},
      ],
      prazos: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
    }
  },
  methods: {
    async consultarJuridica() {
        if (!this.registro.CPF) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o CNPJ para consultar!')
          if (this.$refs.inputCNPJ && this.$refs.inputCNPJ.$el) {
            this.$refs.inputCNPJ.$el.focus()
          }
          return
        }

        try {
          this.$store.commit('controle/setAguardando', true)
          const { data } = await this.$http.post('/api/protected/integrador/consultarJuridica', { cnpj: this.registro.CPF })

          if (data.status === 'success' && data.data) {
            const d = data.data
            this.registro.NOME = d.razao
            this.registro.REZUMIDO = d.nome
            this.registro.ENDERECO = d.endereco
            this.registro.BAIRRO = d.bairro
            this.registro.NUMERO = d.numero
            this.registro.ID_UF = d.ufId
            await this.carregarMunicipios()
            this.registro.ID_MUNICIPIO = d.municipioId
            this.registro.TELEFONE = d.telefone
          } else {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'CNPJ não localizado!')
          }
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
    },
    traduzirTipoPessoa(valor) {
      const mapa = {
        '0': 'Física',
        '1': 'Jurídica'
      }

      return mapa[String(valor)] || '-'
    },
    traduzirTipoContrato(valor) {
      const mapa = {
        '0': 'Vendedor Contratado',
        '1': 'Vendedor Representante'
      }

      return mapa[String(valor)] || '-'
    },
      
    async post () {
      try {
        this.$store.commit('controle/setAguardando', true)
        if (this.avisos()) {
          this.$store.commit('controle/setAguardando', false)
          await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Prencha todos os dados obrigatórios!' )
          return
        }
        
        // Limpar máscara do telefone antes de enviar
        const registroParaEnviar = { ...this.registro }
        if (registroParaEnviar.TELEFONE) {
          registroParaEnviar.TELEFONE = registroParaEnviar.TELEFONE.replace(/\D/g, '')
        }
        
        if ((this.$route.params.id === undefined )) {
          
          const registroPayload = { registro: registroParaEnviar, 
                                    login: window.localStorage.getItem('login')}

          const {data} = await this.$http.post(`/api/protected/vendedor/post`, registroPayload)
          const item = data?.registro?.[0] ?? {}
          if (!item || !item.CODIGO) {
            throw new Error('Erro ao cadastrar o vendedor')
          }
          this.$store.commit("vendedor/SET_REGISTRO_SELECIONADO_ID", item.CODIGO)
          await  this.$store.dispatch('vendedor/GERAR_LISTA')
          this.$router.push(`/cadastros/vendedor/index`)
        } else  {
          registroParaEnviar.NATUREZA = registroParaEnviar.UTILIZACAO
          await this.$http.post(`/api/protected/vendedor/edit`, registroParaEnviar)
          await  this.$store.dispatch('vendedor/GERAR_LISTA')
          this.$router.push(`/cadastros/vendedor/index`)
        }
      } catch(erro) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Erro ao gravar o registro!' )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
   
    async carregarEstados() {
      try {
        const {data}  = await this.$http.get('/api/protected/estados')
        this.estados = data
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os Estados!')
        return
      }
    },
    async carregarMunicipios() {
      if (!this.registro.ID_UF) {
        this.municipios.items = []
        return
      }
      try {
        this.municipios.busy = true
        const {data}  = await this.$http.get( `/api/protected/municipios/${this.registro.ID_UF}`)
        this.municipios.items = data
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os Municípios!')
        return
      } finally {
        this.municipios.busy = false
      }
    },
    
    limparRegistro () {
      let registroVazio =
        {
          CODIGO : null
          ,NOME : null
          ,REZUMIDO : null
          ,CARGO : null
          ,TELEFONE : null
          ,ENDERECO : null
          ,NUMERO : null
          ,CIDADE : null
          ,BAIRRO : null
          ,UF : null
          ,SETOR : '1'
          ,STATUS : '1'
          ,FIZ_JUR : '0'
          ,TIPO_CONTRATO : '0'
          ,OBS1 : null
          ,OBS2   : null
          ,AREA : null
          ,VL_META : 0.00
          ,ID_MUNICIPIO : null
          ,ID_UF : null
          ,ID_USUARIO : null
          ,CPF : null
          ,OP_PERMITE_LIBERAR_VENDA_PRAZO : null
          ,DATA_CADASTRO : null
          ,DATA_ALTERACAO : null
          ,USUARIO_CADASTRO : null
          ,USUARIO_ALTERACAO : null
        }
      this.registro = registroVazio
    },
    async iniciarFormNovo () {
      try {
        const loaders = [this.carregarEstados(), this.carregarMunicipios()]
        await Promise.all(loaders)
        this.limparRegistro()
        this.desabilitado = false
      } catch(error) {
        throw error
      }
    },
    async iniciarFormEditar ( id ) {
      try {
        this.$store.commit('controle/setAguardando', true)
        const {data} = await this.$http.get(`/api/protected/vendedor/getById/${id}`)
        
        this.registro = {...data?.[0] ?? {}}
        if (!this.registro) {
            await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nenhum vendedor encontrado!' )
            this.$router.replace('/cadastros/vendedor/pesquisa') 
            return
        }
        if (this.registro.FIZ_JUR == null) {
          this.registro.FIZ_JUR = '0'
        }
        if (this.registro.TIPO_CONTRATO == null) {
          this.registro.TIPO_CONTRATO = '0'
        }
        const loaders = [this.carregarEstados(), this.carregarMunicipios()]
        await Promise.all(loaders)

        this.registro.VL_META = this.registro.VL_META ? this.registro.VL_META : 0.00 

      } catch(err) {
        throw err
      }
    },
    avisos() {
      return this.nomeValid == false
        || this.registro.STATUS == null
        || this.registro.FIZ_JUR == null
        || this.registro.TIPO_CONTRATO == null
        || this.registro.ID_UF == null
        || this.registro.ID_MUNICIPIO == null
        || this.registro.VL_META == null
        || this.registro.AREA == null  
    }
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    nomeValid() {
      return ((this.registro.NOME ) && (this.registro.NOME.length > 4)) ? true : false
    },
    
  },
  async created () {
    try {
      let id = this.$route.params.id
      if ( id ) {
        await this.iniciarFormEditar( id )
      } else {
        await this.iniciarFormNovo()
      }
    } catch(error) {
        await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nenhum vendedor encontrado!' )
        this.$router.replace('/cadastros/vendedor/pesquisa')
        return
    }
    finally {
      this.$store.commit('controle/setAguardando', false)
    }
  },
  watch: {
    'registro.ID_UF': async function () {
      await this.carregarMunicipios()
    }
  }
}
</script>

<style lang="css" scoped>
.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  margin-bottom: 0.5rem;
}

.shadow-xs {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.rounded-pill {
  border-radius: 50rem !important;
}

.transition-hover {
  transition: all 0.2s ease-in-out;
}

.transition-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}

/* Custom input styles */
.form-control:focus {
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);
}

.card {
  border-radius: 1rem;
}

.card-header {
  background-color: transparent;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  padding: 1.25rem 1.5rem;
}

.btn-glass {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 50px;
  transition: all 0.3s ease;
}

.btn-glass:hover {
  background: rgba(255, 255, 255, 0.25);
  color: white;
  transform: translateY(-1px);
}

.btn-glass-success:hover {
  background: rgba(40, 167, 69, 0.8);
  border-color: rgba(40, 167, 69, 0.9);
}
</style>
          ,AREA : null
          ,VL_META : 0.00
          ,ID_MUNICIPIO : null
          ,ID_UF : null
          ,ID_USUARIO : null
          ,CPF : null
          ,OP_PERMITE_LIBERAR_VENDA_PRAZO : null
          ,DATA_CADASTRO : null
          ,DATA_ALTERACAO : null
          ,USUARIO_CADASTRO : null
          ,USUARIO_ALTERACAO : null
        }
      this.registro = registroVazio
    },
    async iniciarFormNovo () {
      try {
        const loaders = [this.carregarEstados(), this.carregarMunicipios()]
        await Promise.all(loaders)
        this.limparRegistro()
        this.desabilitado = false
      } catch(error) {
        throw error
      }
    },
    async iniciarFormEditar ( id ) {
      try {
        this.$store.commit('controle/setAguardando', true)
        const {data} = await this.$http.get(`/api/protected/vendedor/getById/${id}`)
        
        this.registro = {...data?.[0] ?? {}}
        if (!this.registro) {
            await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nenhum vendedor encontrado!' )
            this.$router.replace('/cadastros/vendedor/pesquisa') 
            return
        }
        const loaders = [this.carregarEstados(), this.carregarMunicipios()]
        await Promise.all(loaders)

        this.registro.VL_META = this.registro.VL_META ? this.registro.VL_META : 0.00 

      } catch(err) {
        throw err
      }
    },
    avisos() {
      return this.nomeValid == false
        || this.registro.STATUS == null
        || this.registro.ID_UF == null
        || this.registro.ID_MUNICIPIO == null
        || this.registro.VL_META == null
        || this.registro.AREA == null  
    }
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    nomeValid() {
      return ((this.registro.NOME ) && (this.registro.NOME.length > 4)) ? true : false
    },
    
  },
  async created () {
    try {
      let id = this.$route.params.id
      if ( id ) {
        await this.iniciarFormEditar( id )
      } else {
        await this.iniciarFormNovo()
      }
    } catch(error) {
        await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nenhum vendedor encontrado!' )
        this.$router.replace('/cadastros/vendedor/pesquisa')
        return
    }
    finally {
      this.$store.commit('controle/setAguardando', false)
    }
  },
  watch: {
    'registro.ID_UF': async function () {
      await this.carregarMunicipios()
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/views/cadastros/vendedor/VendedorCadastro.vue